import { cva, type VariantProps } from "class-variance-authority";
import type { TwcComponentProps } from "react-twc";
import { twc } from "../utils";

const widgetCardVariants = cva("bg-widget-bg rounded-2xl shadow-sm", {
  variants: {
    $padding: {
      default: "p-4",
      md: "p-5",
      lg: "p-6",
      none: "",
    },
  },
  defaultVariants: {
    $padding: "default",
  },
});

type WidgetCardProps = TwcComponentProps<"div"> & VariantProps<typeof widgetCardVariants>;

export const WidgetCard = twc.div<WidgetCardProps>(({ $padding }) =>
  widgetCardVariants({ $padding }),
);

/**
 * Styled wrapper for error/not-found states inside widgets.
 * This is a presentational wrapper only — it does NOT add `role="alert"` or
 * `aria-live`. Call sites displaying dynamic errors must add those attributes.
 */
export const WidgetErrorCard = twc.div`bg-widget-bg rounded-2xl p-4 shadow-sm text-sm text-text-secondary`;
